module.exports = __webpack_public_path__ + "static/media/Program20.dc5bb112.jpg";